<template>
  <div>
    <div class="m-grid__item m-grid__item--fluid m-wrapper breadcums-barr">
		  <!-- BEGIN: Subheader -->
		  <div class="m-subheader ">
		  	<div class="d-flex align-items-center">
		  		<div class="mr-auto">
		  			<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
		  				<li class="m-nav__item">
		  					<span class="m-nav__link-text">
		  						{{property}}
		  					</span>
		  				</li>
		  				<li class="m-nav__separator">
		  					-
		  				</li>
		  				<li class="m-nav__item">
		  					<span class="m-nav__link-text">
		  						{{company}}
		  					</span>
		  				</li>
              <li class="m-nav__separator">
		  					-
		  				</li>
		  				<li class="m-nav__item">
		  					<span class="m-nav__link-text">
		  						{{profile}}
		  					</span>
		  				</li>
		  			</ul>
		  		</div>
		  	</div>
		  </div>
    </div>

    <div class="content">
      <div class="option">
        <div class="contentIcon">
          <div class="icon fa fa-clock-o"></div>
        </div>
        <div class="contentData">
          <div class="title">{{ 'date_time' | capitalize }}</div>
          <div class="result">
            {{this.currentTime}}
          </div>
        </div>
      </div>

       <div class="option">
        <div class="contentIcon">
          <div class="icon fa fa-sitemap"></div>
        </div>
        <div class="contentData">
          <div class="title">{{ 'ip_address_monitor' | capitalize }}</div>
          <div class="result">
            <div><b>{{ 'ip_address' | capitalize }}:</b> {{ip}}</div>
            <div><b>{{ 'netmask' | capitalize }}:</b> {{netmask}}</div>
            <div><b>{{ 'gateway' | capitalize }}:</b> {{broadcast}}</div>
            <div><b>{{ 'addressing_monitor' | capitalize }}:</b> {{typeNetplan | capitalize}}</div>
          </div>
        </div>
      </div>

       <div class="option">
        <div class="contentIcon">
          <div class="icon fa fa-building"></div>
        </div>
        <div class="contentData">
          <div class="title">{{ 'basic_data' | capitalize }}</div>
          <div class="result">
            <div><b>{{ 'property' | capitalize }}:</b> {{property}}</div>
            <div><b>{{ 'database' | capitalize }}:</b> {{database}}</div>
          </div>
        </div>
      </div>

       <div class="option">
        <div class="contentIcon">
          <div class="icon fa fa-tasks"></div>
        </div>
        <div class="contentData">
          <div class="title">{{ 'memory_ram' | capitalize }}</div>
          <div class="result">
            <div><b>{{ 'total' | capitalize }}:</b> {{memoryTotal}}G</div>
            <div><b>{{ 'used' | capitalize }}:</b> {{memoryUsed}}G</div>
            <div><b>{{ 'free' | capitalize }}:</b> {{memoryFree}}G</div>
          </div>
        </div>
      </div>

       <div class="option">
        <div class="contentIcon">
          <div class="icon fa fa-database"></div>
        </div>
        <div class="contentData">
          <div class="title">{{ 'hard_disk' | capitalize }}</div>
          <div class="result">
            <div><b>{{ 'total' | capitalize }}:</b> {{diskTotal}}</div>
            <div><b>{{ 'used' | capitalize }}:</b> {{diskUsed}}</div>
            <div><b>{{ 'free' | capitalize }}:</b> {{diskFree}}</div>
          </div>
        </div>
      </div>

      <div class="option">
        <div class="contentIcon">
          <div class="icon fa fa-microchip"></div>
        </div>
        <div class="contentData">
          <div class="title">{{ 'CPU' | capitalize }}</div>
          <div class="result">
            <div><b>{{ 'CPU' | capitalize }}:</b> {{referenceCpu}}</div>
            <div><b>{{ 'cores' | capitalize }}:</b> {{countCoreCpu}}</div>
            <div><b>{{ 'temperature' | capitalize }}: {{ temperatureCpu | capitalize }}</b>
</div>
          </div>
        </div>
      </div>

       <div class="option">
        <div class="contentIcon">
          <div class="icon fa fa-desktop"></div>
        </div>
        <div class="contentData">
          <div class="title">{{ 'operative_system' | capitalize }}</div>
          <div class="result">{{operativeSystem}}</div>
        </div>
      </div>

       <div class="option">
        <div class="contentIcon">
          <div class="icon fa fa-check-square"></div>
        </div>
        <div class="contentData">
          <div class="title">{{ 'execution_status' | capitalize }}</div>
          <div class="result">
            <div>
              <b>{{ 'last_sync_up' | capitalize }}:</b>
              <br />
              <span>{{ lastSyncUp | capitalize }}</span>
              <span v-if="sincronizationUp === false" class="inactive">{{ 'disconnected' | capitalize }}</span>
            </div>
            <div>
              <b>{{ 'last_sync_down' | capitalize }}:</b>
              <br />
              <span>{{ lastSyncDown | capitalize }}</span>
              <span v-if="sincronizationDown === false" class="inactive">{{ 'disconnected' | capitalize }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="option">
        <div class="contentIcon">
          <div class="icon fa fa-server"></div>
        </div>
        <div class="contentData">
          <div class="title">{{ 'firmware_version' | capitalize }}</div>
          <div class="result">{{firmware}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      myOptions: {
        layout: {
          color: 'black',
          backgroundColor: 'lightgray',
          selectedColor: 'white',
          selectedBackgroundColor: 'green',
          borderColor: 'black',
          fontFamily: 'Arial',
          fontWeight: 'normal',
          fontWeightSelected: 'bold',
          squareCorners: false,
          noBorder: false
        },
        size: {
          fontSize: 14,
          height: 34,
          padding: 7,
          width: 100
        },
        items: {
          delay: 0.4,
          preSelected: 'unknown',
          disabled: false,
          labels: [
            {name: 'Off', color: 'white', backgroundColor: 'red'},
            {name: 'On', color: 'white', backgroundColor: 'green'}
          ]
        }
      },
      show_modal: false,
      currentTime: Date.now(),
      interval: null,
      ip: '',
      netmask: '',
      broadcast: '',
      memoryTotal: '',
      memoryUsed: '',
      memoryFree: '',
      diskTotal: '',
      diskUsed: '',
      diskFree: '',
      referenceCpu: '',
      countCoreCpu: '',
      temperatureCpu: '',
      operativeSystem: '',
      firmware: '',
      database: '',
      property: '',
      serverWeb: '',
      sincronizationUp: '',
      sincronizationDown: '',
      company: '',
      profile: '',
      timeZoneHour: 0,
      timeZoneMinute: 0,
      timeZoneSimbol: '',
      lastSyncUp: '',
      lastSyncDown: '',
      typeNetplan: ''
    }
  },
  methods: {
    ...mapActions(['retriveDataHome', 'getPropertyInfo']),
    updateCurrentTime: function () {
      var datedate = new Date().toISOString()
      var simbolTimeZone = ''
      if (this.timeZoneSimbol === '-') {
        simbolTimeZone = '-'
      } else {
        simbolTimeZone = ''
      }

      var dateNow = moment(datedate).utc(0).add(simbolTimeZone + this.timeZoneHour, 'hours').add(simbolTimeZone + this.timeZoneMinute, 'minutes').format('DD/MM/YYYY - h:mm:ss a')
      this.currentTime = dateNow
    }
  },
  mounted () {
    this.interval = setInterval(this.updateCurrentTime, 1000)
    this.$spinner.show()
    this.retriveDataHome(this.shard)
      .then((res) => {
        if (res.status === 200) {
          this.ip = res.data.ip.ip
          this.netmask = res.data.ip.netmask
          this.broadcast = res.data.ip.broadcast
          this.memoryTotal = res.data.memory.MemTotal
          this.memoryUsed = res.data.memory.MemAvailable
          this.memoryFree = res.data.memory.MemFree
          this.diskTotal = res.data.hardDisk.diskTotal
          this.diskUsed = res.data.hardDisk.diskUsage
          this.diskFree = res.data.hardDisk.diskFree
          this.referenceCpu = res.data.cpu.cpuReference
          this.countCoreCpu = res.data.cpu.countCoreCpu
          this.temperatureCpu = res.data.cpu.temperatureCpu
          this.operativeSystem = res.data.operativeSystem
          this.firmware = res.data.firmware
          this.database = res.data.database
          this.property = res.data.property
          this.serverWeb = res.data.executeStatus.serverWeb
          this.sincronizationUp = res.data.executeStatus.sincronizationUp
          this.sincronizationDown = res.data.executeStatus.sincronizationDown
          this.profile = res.data.profile
          this.company = res.data.company
          this.timeZoneHour = res.data.timeZoneHour
          this.timeZoneMinute = res.data.timeZoneMinute
          this.timeZoneSimbol = res.data.timeZoneSimbol
          this.typeNetplan = res.data.ip.typeNetplan
          if (res.data.executeStatus.lastSyncUp !== 'not_found') {
            this.lastSyncUp = moment(res.data.executeStatus.lastSyncUp).format('YYYY/MM/DD hh:mm:ss')
          } else {
            this.lastSyncUp = 'not_found'
          }

          if (res.data.executeStatus.lastSyncDown !== 'not_found') {
            this.lastSyncDown = moment(res.data.executeStatus.lastSyncDown).format('YYYY/MM/DD hh:mm:ss')
          } else {
            this.lastSyncDown = 'not_found'
          }

          this.$spinner.remove()
        }
      })
      .catch((err) => {
        this.$spinner.remove()
        console.log(err)
      })
  },
  computed: {
    ...mapGetters({ shard: 'getUserShard' }),
    time: function () {
      this.hours + ':' + this.minutes + ':' + this.seconds
      return ''
    },
    milliseconds: function () {
      return this.currentTime
    },
    hours: function () {
      var hrs = new Date().getHours()
      if (hrs >= 13) { hrs = hrs - 12 }
      return hrs >= 10 ? hrs : '0' + hrs
    },
    minutes: function () {
      var milli = this.milliseconds
      var min = Math.floor((milli / 60000) % 60)
      return min >= 10 ? min : '0' + min
    },
    seconds: function () {
      var milli = this.milliseconds
      var sec = Math.ceil((milli % 60000) / 1000).toFixed(0)
      if (sec === '60') {
        sec = 0
      }
      return (sec >= 10 && sec !== 0) ? sec : '0' + sec
    }
  }
}
</script>

<style scope>
.content {
  padding-top: 10px;
  padding-right: 20px;
  padding-bottom: 10px;
  padding-left: 60px;
  display: table;
}

@media (min-width: 0px) {
  .option {
    margin:10px;
    border: 1px solid #00184a;
    width: 97%;
    height:110px;
    display:inline-table;
    vertical-align:middle;
    background:#fff;
    font-family: roboto;
  }
}

@media (min-width: 320px) {
  .option {
    margin:10px;
    border: 1px solid #00184a;
    width: 97%;
    height:110px;
    display:inline-table;
    vertical-align:middle;
    background:#fff;
    font-family: roboto;
  }
}

@media (min-width: 480px) {
  .option {
    margin:10px;
    border: 1px solid #00184a;
    width: 45%;
    height:110px;
    display:inline-table;
    vertical-align:middle;
    background:#fff;
    font-family: roboto;
  }
}

@media (min-width: 768px) {
  .option {
    margin:10px;
    border: 1px solid #00184a;
    width: 47%;
    height:110px;
    display:inline-table;
    vertical-align:middle;
    background:#fff;
    font-family: roboto;
  }
}

@media (min-width: 1000px) {
  .option {
    margin:10px;
    border: 1px solid #00184a;
    width: 45%;
    height:110px;
    display:inline-table;
    vertical-align:middle;
    background:#fff;
    font-family: roboto;
  }
}

@media (min-width: 1200px) {
  .option {
    margin:10px;
    border: 1px solid #00184a;
    width: 30%;
    height:110px;
    display:inline-table;
    vertical-align:middle;
    background:#fff;
    font-family: roboto;
  }
}

.principalTitle {
  text-align:center;
  color: #00184a;
  font-size: 3.2em;
  padding-top:10px;
  font-weight: bold;
}

.option .contentIcon {
  width:25%;
  display:table-cell;
  background-color: #00184a;
  vertical-align: middle;
  text-align:center;
  height: 100% !important;
}

.option .contentIcon .icon {
  font-size:3.8em;
  color: #fff;
  vertical-align: middle;
}

.option:hover .contentIcon .icon {
  -webkit-transition: all 200ms linear;
  -moz-transition: all 200ms linear;
  -ms-transition: all 200ms linear;
  -o-transition: all 200ms linear;
  transition: all 200ms linear;
  -moz-transform: scale(1.3);
  -webkit-transform: scale(1.3);
  -o-transform: scale(1.3);
  -ms-transform: scale(1.3);
  transform: scale(1.3);
}

.option .contentData {
  display:inline-table;
  width:100%;
  vertical-align:top;
  padding:1%;
}

.option .contentData .title {
  font-size:1.3em;
  font-weight: bold;
  margin:0px;
  text-align: center;
}

.option .contentData .result {
  color:grey;
  font-size: 1em;
  margin:0px;
  padding-left: 0.3em;
}
.active {
  font-weight: bold;
  color:darkgreen;
}

.inactive {
  font-weight: bold;
  color:darkred;
  font-size: 0.8em;
  padding: 0.5em;
  font-family: roboto;
}

.breadcums-barr {
  margin-bottom: 10px !important;
}
</style>



// WEBPACK FOOTER //
// Home.vue